export default {
  IMMUNISATION: 'Immunisation',
  WWCC: 'Working with Children'
}
